// Redesign 2026 – filtr dokumentů podle druhu (Sbírka listin).
//
// Bez JS jsou vidět všechny dokumenty a tlačítka filtru zůstanou schovaná (`hidden`) – stránka
// funguje dál, filtrování je jen zrychlení. Nefiltruje se serverem, dokumentů jsou desítky.
//
// Markup: [data-rd-doc-filter] s tlačítky [data-rd-filter="<druh>"] (prázdná hodnota = vše),
// roky [data-rd-doc-year] uvnitř [data-rd-doc-list], dokumenty [data-rd-doc-type="<druh>"].
// Rok, ve kterém po filtru nezbyde žádný dokument, se schová celý i s letopočtem.

const ACTIVE = 'is-active';

export default function initRedesignDocFilter() {
  const group = document.querySelector('[data-rd-doc-filter]');
  const list = document.querySelector('[data-rd-doc-list]');
  if (!group || !list) {
    return;
  }

  const buttons = [...group.querySelectorAll('[data-rd-filter]')];
  const years = [...list.querySelectorAll('[data-rd-doc-year]')].map((el) => ({
    el,
    docs: [...el.querySelectorAll('[data-rd-doc-type]')],
  }));

  const apply = (type) => {
    years.forEach(({ el: year, docs }) => {
      let shown = 0;

      docs.forEach((doc) => {
        const match = type === '' || doc.dataset.rdDocType === type;
        doc.hidden = !match;
        if (match) {
          shown += 1;
        }
      });

      year.hidden = shown === 0;
    });

    buttons.forEach((button) => {
      const isActive = button.dataset.rdFilter === type;
      button.classList.toggle(ACTIVE, isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  group.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rd-filter]');
    if (button) {
      apply(button.dataset.rdFilter);
    }
  });

  group.hidden = false;
}
